import { cls } from "../soft/SoftKit";

/** Hatim satırının iskeleti: gerçek satırla aynı düzen (simge, ad, çubuk). */
export default function HatimCardSkeleton() {
  return (
    <li className={`flex flex-col gap-2 px-4 py-3 ${cls.row}`}>
      <div className="flex items-center gap-3">
        <span className={`w-9 h-9 rounded-full shrink-0 ${cls.skeleton}`} />
        <div className="flex-1 flex flex-col gap-1.5">
          <span className={`h-4 w-1/2 rounded ${cls.skeleton}`} />
          <span className={`h-3 w-1/3 rounded ${cls.skeleton}`} />
        </div>
        <span className={`h-8 w-20 rounded-full ${cls.skeleton}`} />
      </div>
      <div className="flex items-center gap-3 pl-12">
        <span className={`h-1 flex-1 rounded-full ${cls.skeleton}`} />
        <span className={`h-3 w-24 rounded ${cls.skeleton}`} />
      </div>
    </li>
  );
}
